import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Image } from "@zillow/constellation-10";
import { v8ResponsiveToPanda } from "../../utils/token-migration/migrate-responsive.esm.js";
const baseBackgroundImageClass = css({
  pointerEvents: "none",
  position: "absolute",
  top: "0",
  right: "0",
  bottom: "0",
  left: "0",
  width: "100%",
  height: "100%"
});
function buildFitPositionClass(fitBase, fitLg, fitXl, posBase, posLg, posXl) {
  const fitMobile = fitBase || "cover";
  const fitTablet = fitLg || fitMobile;
  const fitDesktop = fitXl || fitTablet;
  const posMobile = posBase || "50% 50%";
  const posTablet = posLg || posMobile;
  const posDesktop = posXl || posTablet;
  return css({
    objectFit: fitMobile,
    objectPosition: posMobile,
    lg: {
      objectFit: fitTablet,
      objectPosition: posTablet
    },
    xl: {
      objectFit: fitDesktop,
      objectPosition: posDesktop
    }
  });
}
function resolveDisplay(visible) {
  if (!visible) return void 0;
  if (typeof visible === "object") {
    return v8ResponsiveToPanda(visible, (v) => v ? "initial" : "none");
  }
  return void 0;
}
const GroupBackgroundImage = ({
  backgroundPosition = "50% 50%",
  backgroundSize = {
    default: "cover"
  },
  backgroundImageVisible,
  className,
  style,
  ...rest
}) => {
  const fitPanda = typeof backgroundSize === "object" ? v8ResponsiveToPanda(backgroundSize) : {
    base: backgroundSize
  };
  const fitBase = fitPanda.base;
  const fitLg = fitPanda.md ?? fitPanda.lg ?? fitBase;
  const fitXl = fitPanda.xl ?? fitLg;
  const posPanda = typeof backgroundPosition === "object" ? v8ResponsiveToPanda(backgroundPosition) : {
    base: backgroundPosition
  };
  const posBase = posPanda.base;
  const posLg = posPanda.md ?? posPanda.lg ?? posBase;
  const posXl = posPanda.xl ?? posLg;
  const fitPositionClass = buildFitPositionClass(fitBase, fitLg, fitXl, posBase, posLg, posXl);
  const display = resolveDisplay(backgroundImageVisible);
  const displayClass = display ? css({
    display
  }) : void 0;
  return /* @__PURE__ */ jsx(Image, { alt: "", className: [baseBackgroundImageClass, fitPositionClass, displayClass, className].filter(Boolean).join(" "), style: {
    height: "100%",
    ...style
  }, ...rest });
};
export {
  GroupBackgroundImage as default
};
